import React from 'react';
import { ValidationErrors } from 'constants/validations';
import { Col, CountrySelect, Form, FormModal, Input, Row, Select } from 'components';
import { useAddOrder } from './useAddOrder';

const { Item } = Form;
const { TextArea } = Input;

export interface IAddOrderModal {
  modalState: boolean;
  onModalStateChange: () => void;
}

export const AddOrderModal: React.FC<IAddOrderModal> = (props) => {
  const { onModalStateChange, modalState } = props;
  const { onFinish, form, onCancel, isLoading } = useAddOrder({ onModalStateChange });

  return (
    <FormModal
      form={form}
      title={'Add Order'}
      okText={'Add'}
      open={modalState}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Item
                label={'Client*'}
                name={'clientId'}
                rules={[{ required: true, message: ValidationErrors.required('Client') }]}
              >
                <Select size={'large'} placeholder={'Select client'} />
              </Item>
            </Col>
            <Col span={12}>
              <Item
                name="deliveryCountryId"
                label={'Delivery Country*'}
                rules={[
                  {
                    required: true,
                    message: ValidationErrors.required('Delivery Country'),
                  },
                ]}
              >
                <CountrySelect size={'large'} maxTagCount={'responsive'} />
              </Item>
            </Col>
            <Col span={24}>
              <Item label={'Notes'} name={'notes'}>
                <TextArea rows={4} />
              </Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </FormModal>
  );
};
